import { ref, watch } from "vue";
import UsersApi from "@/common/http/UsersApi";

export function useAtsUserSearch(atsUserIdSource) {
  const atsUserOptions = ref([]);
  const atsUserLoading = ref(false);

  async function fetchAtsUsers(atsUserId) {
    if (atsUserId) {
      try {
        const { data } = await UsersApi.settingsAtsUsers({ ids: [atsUserId] });
        atsUserOptions.value = data.atsUsers;
      } catch {
        atsUserOptions.value = [];
      }
    }
  }

  async function remoteAtsUserSearch(query) {
    if (query) {
      atsUserLoading.value = true;
      try {
        const { data } = await UsersApi.settingsAtsUsers({ q: query });
        atsUserOptions.value = data.atsUsers;
      } catch {
        atsUserOptions.value = [];
      } finally {
        atsUserLoading.value = false;
      }
    } else {
      atsUserOptions.value = [];
    }
  }

  if (typeof atsUserIdSource === "function") {
    watch(atsUserIdSource, (newId) => {
      if (newId && !atsUserOptions.value.some(u => u.id === newId)) {
        fetchAtsUsers(newId);
      }
    }, { immediate: true });
  }

  return { atsUserOptions, atsUserLoading, fetchAtsUsers, remoteAtsUserSearch };
}
